import React from "react";
import Stats from "./Stats";
import System from "./System";

const Home = () => {
    return (
        <>
            <Stats />
            <System />
        </>
    );
};

export default Home;
